module.exports = __webpack_public_path__ + "static/img/59.1cb4f69.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/face/59.gif
// module id = 3g7D
// module chunks = 2